
import {
  BlockText,
  PinnedNotificationBlock,
  BlockCallToActionBlock,
  NewsletterSubscribeBlock,
  DownloadBlock,
} from '../implementations';
import DonationInitializerBlock from '../implementations/Block/DonationInitializerBlock';


const mappers = {
  text: BlockText,
  pinned_notification: PinnedNotificationBlock,
  call_to_action: BlockCallToActionBlock,
  newsletter_subscribe: NewsletterSubscribeBlock,
  donation_initializer: DonationInitializerBlock,
  download: DownloadBlock,
};

export default mappers;
